(function(){
  function normalizeVariantId(value){
    if(value===null||value===undefined)return '';
    var text=String(value);
    return text.indexOf('/')!==-1?text.split('/').pop():text;
  }

  function variantIdFromDetail(detail){
    if(!detail)return '';
    var variant=detail.variant;
    if(variant&&typeof variant==='object')return variant.id||variant.variantId||'';
    return variant||detail.variantId||'';
  }

  function readCommerceVariants(commerce){
    if(!commerce)return [];
    if(commerce.__dagVariantRecords)return commerce.__dagVariantRecords;
    var script=commerce.querySelector('[data-dag-commerce-variants]');
    if(!script)return [];
    try{commerce.__dagVariantRecords=JSON.parse(script.textContent||'[]');}
    catch(error){commerce.__dagVariantRecords=[];}
    return commerce.__dagVariantRecords;
  }

  function formatDimension(value){
    var number=Number(value);
    if(!isFinite(number))return '';
    return number%1===0?String(number):String(number).replace(/\.0+$/,'');
  }

  function editionText(commerce,record){
    var productClass=(commerce.getAttribute('data-dag-product-class')||'').toUpperCase();
    var scope=(commerce.getAttribute('data-dag-edition-scope')||'').toLowerCase();
    var curated=commerce.getAttribute('data-dag-curated-set')==='true';
    if(curated)return '';
    if(productClass==='ORIGINAL_ARTWORK')return 'Unique work · 1/1';
    if(productClass==='OPEN_EDITION_FINE_ART_PRINT'||productClass==='LICENSED_CURATED_PHOTOGRAPHY')return 'Open edition';
    if(productClass!=='LIMITED_EDITION')return '';
    if(record.editionNumber!==null&&record.editionNumber!==undefined&&record.editionSize!==null&&record.editionSize!==undefined){
      return String(record.editionNumber)+'/'+String(record.editionSize);
    }
    if(record.editionSize!==null&&record.editionSize!==undefined){
      return 'Edition of '+String(record.editionSize)+(scope==='per size'?' · selected size':'');
    }
    return 'Limited edition';
  }

  function updateDagCommerceVariant(pdp,variantId){
    if(!pdp)return false;
    var commerce=pdp.querySelector('[data-dag-artwork-commerce]');
    if(!commerce)return false;
    var target=normalizeVariantId(variantId);
    if(!target)return false;
    var records=readCommerceVariants(commerce);
    var record=null;
    for(var i=0;i<records.length;i+=1){
      if(normalizeVariantId(records[i].id)===target){record=records[i];break;}
    }
    if(!record)return false;

    var sizeLine=commerce.querySelector('[data-dag-commerce-size]');
    var sizeValue=commerce.querySelector('[data-dag-commerce-size-value]');
    if(sizeLine&&sizeValue){
      var renderedSize='';
      if(record.sizeLabel)renderedSize=String(record.sizeLabel);
      else if(record.widthCm!==null&&record.widthCm!==undefined&&record.heightCm!==null&&record.heightCm!==undefined)renderedSize=formatDimension(record.heightCm)+' × '+formatDimension(record.widthCm)+' cm';
      sizeValue.textContent=renderedSize;
      sizeLine.hidden=!renderedSize;
    }

    var editionLine=commerce.querySelector('[data-dag-commerce-edition]');
    var editionValue=commerce.querySelector('[data-dag-commerce-edition-value]');
    if(editionLine&&editionValue){
      var edition=editionText(commerce,record);
      editionValue.textContent=edition;
      editionLine.hidden=!edition;
    }
    return true;
  }

  function ensureFixedOptionGroups(pdp){
    var commerce=pdp&&pdp.querySelector('[data-dag-artwork-commerce]');
    var records=readCommerceVariants(commerce);
    var radiosRoot=pdp&&pdp.querySelector('loess-variant-radios');
    if(!records.length||!radiosRoot)return false;
    var present={};
    optionGroups(pdp).forEach(function(group){
      present[Number(group.getAttribute('data-dag-option-position'))]=true;
    });
    var inserted=false;
    var optionCount=records.reduce(function(max,record){return Math.max(max,(record.options||[]).length);},0);
    for(var position=1;position<=optionCount;position+=1){
      if(present[position])continue;
      var values=[];
      records.forEach(function(record){
        var value=record.options&&record.options[position-1];
        if(value!==null&&value!==undefined&&value!==''&&values.indexOf(String(value))===-1)values.push(String(value));
      });
      if(values.length!==1)continue;
      var fieldset=document.createElement('fieldset');
      fieldset.className='js dag-option-group dag-option-group--fixed';
      fieldset.hidden=true;
      fieldset.setAttribute('aria-hidden','true');
      fieldset.setAttribute('data-dag-option-name','fixed-option-'+position);
      fieldset.setAttribute('data-dag-option-position',String(position));
      var input=document.createElement('input');
      input.type='radio';
      input.name='Option '+position;
      input.value=values[0];
      input.checked=true;
      input.tabIndex=-1;
      input.setAttribute('data-dag-option-position',String(position));
      input.setAttribute('data-dag-option-value',values[0]);
      var form=pdp.querySelector('form[action*="/cart/add"]');
      if(form&&form.id)input.setAttribute('form',form.id);
      fieldset.appendChild(input);
      radiosRoot.insertBefore(fieldset,radiosRoot.firstChild);
      present[position]=true;
      inserted=true;
    }
    return inserted;
  }

  function optionGroups(pdp){
    return Array.prototype.slice.call(pdp.querySelectorAll('[data-dag-option-position]')).filter(function(el){
      return el.classList.contains('dag-option-group');
    }).sort(function(a,b){return Number(a.getAttribute('data-dag-option-position'))-Number(b.getAttribute('data-dag-option-position'));});
  }

  function groupValue(group){
    var radio=group.querySelector('input[type="radio"]:checked');
    if(radio)return radio.value;
    var select=group.matches('loess-variant-selects')?group.querySelector('select'):group.querySelector('select');
    return select?select.value:'';
  }

  function choicesForGroup(group){
    var radios=Array.prototype.slice.call(group.querySelectorAll('input[type="radio"][data-dag-option-value]'));
    if(radios.length){
      return radios.map(function(input){return {kind:'radio',node:input,value:input.value,label:group.querySelector('label[for="'+input.id.replace(/"/g,'\\"')+'"]')};});
    }
    var select=group.querySelector('select');
    if(select){
      return Array.prototype.slice.call(select.options).map(function(option){return {kind:'option',node:option,value:option.value,label:null,select:select};});
    }
    return [];
  }

  function matchesSelections(record,selections){
    if(!record||!record.options)return false;
    for(var key in selections){
      if(Object.prototype.hasOwnProperty.call(selections,key)){
        var position=Number(key);
        if(record.options[position-1]!==selections[key])return false;
      }
    }
    return true;
  }

  function setChoiceState(choice,exists,available){
    if(choice.kind==='radio'){
      choice.node.dataset.dagImpossible=exists?'false':'true';
      choice.node.disabled=!available;
      choice.node.classList.toggle('disabled',!available);
      if(choice.label){
        choice.label.hidden=!exists;
        choice.label.classList.toggle('dag-option-unavailable',exists&&!available);
      }
    }else{
      choice.node.hidden=!exists;
      choice.node.disabled=!available;
      choice.node.dataset.dagImpossible=exists?'false':'true';
    }
  }

  function selectChoice(choice){
    if(choice.kind==='radio'){
      if(choice.node.checked)return false;
      choice.node.checked=true;
      choice.node.dispatchEvent(new Event('change',{bubbles:true}));
      return true;
    }
    if(choice.select&&choice.select.value!==choice.value){
      choice.select.value=choice.value;
      choice.select.dispatchEvent(new Event('change',{bubbles:true}));
      return true;
    }
    return false;
  }

  function syncDependentOptions(pdp){
    if(!pdp||pdp.dataset.dagOptionSync==='true')return;
    var commerce=pdp.querySelector('[data-dag-artwork-commerce]');
    var records=readCommerceVariants(commerce);
    var groups=optionGroups(pdp);
    if(!records.length||groups.length<2)return;

    pdp.dataset.dagOptionSync='true';
    try{
      var prior={};
      for(var g=0;g<groups.length;g+=1){
        var group=groups[g];
        var position=Number(group.getAttribute('data-dag-option-position'));
        var choices=choicesForGroup(group);
        var current=groupValue(group);
        var currentExists=false;
        var firstExisting=null;
        var firstAvailable=null;

        choices.forEach(function(choice){
          var criteria={};
          Object.keys(prior).forEach(function(k){criteria[k]=prior[k];});
          criteria[position]=choice.value;
          var exists=records.some(function(record){return matchesSelections(record,criteria);});
          var available=records.some(function(record){return record.available&&matchesSelections(record,criteria);});
          setChoiceState(choice,exists,available);
          if(exists&&!firstExisting)firstExisting=choice;
          if(available&&!firstAvailable)firstAvailable=choice;
          if(choice.value===current&&exists)currentExists=true;
        });

        if(!currentExists){
          var fallback=firstAvailable||firstExisting;
          if(fallback){selectChoice(fallback);current=fallback.value;}
        }
        if(current)prior[position]=current;
      }
    }finally{
      delete pdp.dataset.dagOptionSync;
    }
  }

  function readProductVariants(pdp){
    var script=pdp&&pdp.querySelector('script[id^="ProductVariantData-"]');
    if(!script)return [];
    try{return JSON.parse(script.textContent||'[]');}catch(error){return [];}
  }

  function formatEuroPrice(cents){
    var amount=Number(cents)/100;
    if(!isFinite(amount))return '';
    var currency=(window.Shopify&&window.Shopify.currency&&window.Shopify.currency.active)||'EUR';
    return new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency:currency}).format(amount)+' '+currency;
  }

  function recoverMissingVariant(pdp){
    if(!pdp)return false;
    var variantInput=pdp.querySelector('form[action*="/cart/add"] input[name="id"]');
    if(!variantInput)return false;
    var selections={};
    optionGroups(pdp).forEach(function(group){
      var value=groupValue(group);
      var position=Number(group.getAttribute('data-dag-option-position'));
      if(value&&position)selections[position]=value;
    });
    var variants=readProductVariants(pdp);
    if(!variants.length||optionGroups(pdp).length>=(variants[0].options||[]).length)return false;
    var matches=variants.filter(function(variant){return matchesSelections(variant,selections);});
    if(matches.length!==1)return false;
    var variant=matches[0];
    variantInput.value=String(variant.id);
    var button=pdp.querySelector('[data-dag-acquire-button]');
    if(button)button.disabled=!variant.available;
    var price=pdp.querySelector('.dag-art-market-price .price__regular .price-item--regular');
    if(price&&variant.price!==null&&variant.price!==undefined){
      var formatted=formatEuroPrice(variant.price);
      if(formatted){
        price.textContent=formatted;
        var priceRoot=pdp.querySelector('.dag-art-market-price');
        if(priceRoot){priceRoot.classList.remove('hidden');priceRoot.hidden=false;}
      }
    }
    updateDagCommerceVariant(pdp,variant.id);
    return true;
  }

  function syncDagAcquire(pdp){
    if(!pdp)return;
    var button=pdp.querySelector('[data-dag-acquire-button]');
    if(!button)return;
    var label=button.querySelector('[data-dag-acquire-label]')||button.querySelector('span');
    var availability=pdp.querySelector('[data-dag-availability-label]');
    var unavailable=button.disabled;
    var availableText=button.getAttribute('data-dag-label-available')||'Add to Cart';
    var unavailableText=button.getAttribute('data-dag-label-unavailable')||'Currently unavailable';
    if(label)label.textContent=unavailable?unavailableText:availableText;
    if(availability){
      var availabilityAvailable=availability.getAttribute('data-dag-label-available')||'Available';
      availability.textContent=unavailable?'Currently unavailable':availabilityAvailable;
    }
  }

  function syncCommerceFromForm(pdp){
    var variantInput=pdp&&pdp.querySelector('input[name="id"]');
    if(variantInput)updateDagCommerceVariant(pdp,variantInput.value);
  }

  function bindDagPdp(root){
    root=root||document;
    var pdps=[];
    if(root.matches&&root.matches('[data-dag-art-market-pdp]'))pdps.push(root);
    if(root.querySelectorAll)pdps=pdps.concat(Array.prototype.slice.call(root.querySelectorAll('[data-dag-art-market-pdp]')));
    pdps.forEach(function(pdp){
      syncDependentOptions(pdp);
      recoverMissingVariant(pdp);
      syncCommerceFromForm(pdp);
      syncDagAcquire(pdp);
      if(pdp.dataset.dagA4Bound==='true')return;
      pdp.dataset.dagA4Bound='true';

      pdp.addEventListener('change',function(event){
        if(event.target&&event.target.matches('[data-dag-option-position]'))syncDependentOptions(pdp);
        window.requestAnimationFrame(function(){recoverMissingVariant(pdp);syncCommerceFromForm(pdp);syncDagAcquire(pdp);});
      },true);

      var observer=new MutationObserver(function(){window.requestAnimationFrame(function(){recoverMissingVariant(pdp);syncCommerceFromForm(pdp);syncDagAcquire(pdp);});});
      observer.observe(pdp,{subtree:true,attributes:true,attributeFilter:['disabled']});
    });
  }

  if(!window.__dagA4VariantEvent){
    window.__dagA4VariantEvent=true;
    document.addEventListener('product:variant:changed',function(event){
      var variantId=variantIdFromDetail(event.detail||{});
      document.querySelectorAll('[data-dag-art-market-pdp]').forEach(function(pdp){
        syncDependentOptions(pdp);
        if(variantId)updateDagCommerceVariant(pdp,variantId);
        syncDagAcquire(pdp);
      });
    });
  }

  function init(root){bindDagPdp(root||document);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);},{once:true});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target||document);});

  /* DAG Gifts: stable, server-rendered dimensions. */
  function dagGiftSizeInit(root){
    var nodes=(root||document).querySelectorAll('.dag-gift-pdp [data-dag-gift-dimensions][data-dag-gift-sizes]');
    Array.prototype.forEach.call(nodes,function(grid){
      if(grid.dataset.dagSizeBound==='1')return;
      var data;try{data=JSON.parse(grid.getAttribute('data-dag-gift-sizes')||'{}')}catch(e){return}
      var pdp=grid.closest('.dag-gift-pdp'),input=pdp&&pdp.querySelector('form[action*="/cart/add"] input[name="id"]');
      if(!input)return;
      grid.dataset.dagSizeBound='1';
      var print=grid.querySelector('[data-dag-gift-print]'),frame=grid.querySelector('[data-dag-gift-frame]');
      function sync(id){
        var record=data[String(id||input.value)];if(!record)return;
        function update(el,value){
          if(!el)return;var m=String(value||'').match(/^(.+?)\s*\(([^)]+)\)$/);
          var inches=el.querySelector('.dag-gift-size__imperial'),cm=el.querySelector('.dag-gift-size__metric');
          if(inches)inches.textContent=m?m[1]:value||'';
          if(cm)cm.textContent=m?m[2]:'';
        }
        update(print,record.print);update(frame,record.frame);
      }
      sync();
      pdp.addEventListener('change',function(){requestAnimationFrame(function(){sync()})});
      document.addEventListener('product:variant:changed',function(e){
        var d=e.detail||{},v=d.variant,id=(v&&typeof v==='object'?v.id:v)||d.variantId;
        if(id&&data[String(id)])sync(id);
      });
      new MutationObserver(function(){sync()}).observe(input,{attributes:true,attributeFilter:['value']});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){dagGiftSizeInit(document)},{once:true});else dagGiftSizeInit(document);
  document.addEventListener('shopify:section:load',function(e){dagGiftSizeInit(e.target||document)});
})();
